import { AxiosError } from 'axios';

export interface ApiError {
  message: string;
  messageResKey: string;
  localizedMessage: string;
  errors: any[];
}

export const createApiError = (e?: AxiosError<ApiError>, showAlert = true) => ({
  code: e?.response?.status ?? 500,
  message: e?.response?.data?.message ?? 'Something went wrong, please try again',
  errors: e?.response?.data?.errors,
  showAlert,
});
